import axios from 'axios'

const isTestEnv = location.pathname.match('timber-');
const isLocalEnv = location.pathname.match('mkdesigner');
const isStageEnv = location.pathname.match('xstage');

const SEARCH_PATH = (isLocalEnv ? 'https://new-search.mhme.nu'
  : isTestEnv ? 'https://new-search.mhme.nu'
    : isStageEnv ? 'https://new-search.mhme.nu'
      : 'https://new-search.mhme.nu');

const getTemplates = (key, page, chunk) => {
  return axios.get(`${SEARCH_PATH}/template`, {
    params: {
      key: key,
      page: page,
      chunk: chunk
    }
  });
}

export default {
  getTemplates,
}
